import { useEffect } from "react";
import { useLocation } from "react-router";

type HubspotStatus = {
    loaded: boolean;
    pending: boolean;
};

interface HubSpotWidget {
    load: () => void;
    remove: () => void;
    status: () => HubspotStatus;
}

interface HubSpotConversations {
    widget: HubSpotWidget;
}

declare global {
    interface Window {
        HubSpotConversations?: HubSpotConversations;
    }
}

function load() {
    window.HubSpotConversations?.widget.load();
}

function remove() {
    window.HubSpotConversations?.widget.remove();
}

function isLoadedOrLoading(): boolean {
    const hb = window.HubSpotConversations;
    if (hb) {
        const status = hb.widget.status();
        return status.loaded || status.pending;
    }

    return false;
}

const Loader = () => {
    const location = useLocation();
    const path = location.pathname.toLowerCase();

    useEffect(() => {
        if (path.includes("register")) {
            remove();
            return;
        }

        // Return if Hubspot is already loaded or in the process of loading
        if (isLoadedOrLoading()) return;

        // Otherwise load Hubspot
        load();
    }, [path]);

    return null;
};

export default {
    load,
    remove,
    isLoadedOrLoading,
    Loader,
};
